export default __webpack_public_path__ + "static/media/NotificacaoIcon.8179f61d.svg";